module.exports = __webpack_public_path__ + "img/icon4.a67154c2.png";